/**
 * Liegt der Punkt im Ausschnitt?
 *
 * Die Ränder gehören dazu. Ein Fahrzeug genau auf der Kante hat noch Karte
 * unter sich — und ein Hinweis, der an der Grenze flackert, wäre schlimmer als
 * keiner.
 *
 * Über den Datumsgrenzwechsel hinweg gilt das nicht; für ein Gebiet in Europa
 * gibt es den Fall nicht, und eine Behandlung, die nie durchlaufen wird, wäre
 * eine Behauptung ohne Deckung.
 */
export function containsPoint(bounds, point) {
    return (point.lat >= bounds.minLat &&
        point.lat <= bounds.maxLat &&
        point.lon >= bounds.minLon &&
        point.lon <= bounds.maxLon);
}
//# sourceMappingURL=bounds.js.map